var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBookHelp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 12.75C13.5784 12.75 14.25 12.0784 14.25 11.25C14.25 10.4216 13.5784 9.75 12.75 9.75C11.9216 9.75 11.25 10.4216 11.25 11.25M3.75 6.19098C4.69933 6.338 5.75833 6.58243 6.75 6.96591M9 4.54003V15.75C8.82034 15.75 8.64068 15.6964 8.48762 15.5891C6.89485 14.473 4.65953 13.9672 2.99575 13.7792C2.17232 13.6862 1.5 12.9983 1.5 12.15V3.70138C1.5 2.85302 2.17232 2.16541 2.99575 2.25845C4.65953 2.44646 6.89485 2.95224 8.48762 4.06833C8.79374 4.28284 9.20626 4.28284 9.51238 4.06833C11.1052 2.95224 13.3405 2.44646 15.0043 2.25845C15.8277 2.16541 16.5 2.85302 16.5 3.70138V10.5M3.75 9.19098C4.22962 9.26526 4.73722 9.3644 5.25 9.49377",
    stroke: "#808080",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 15C13.5 15.4142 13.1642 15.75 12.75 15.75C12.3358 15.75 12 15.4142 12 15C12 14.5858 12.3358 14.25 12.75 14.25C13.1642 14.25 13.5 14.5858 13.5 15Z",
    fill: "#808080"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookHelp);
export default __webpack_public_path__ + "static/media/bookHelp.90afb28257d9a0ac6a1e7dedb50f57ac.svg";
export { ForwardRef as ReactComponent };